import { render, staticRenderFns } from "./Resetpass.vue?vue&type=template&id=23cea169&scoped=true&"
import script from "./Resetpass.vue?vue&type=script&lang=js&"
export * from "./Resetpass.vue?vue&type=script&lang=js&"
import style0 from "./Resetpass.vue?vue&type=style&index=0&id=23cea169&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cea169",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Resetpass.vue
// module id = null
// module chunks = 